// extracted by mini-css-extract-plugin
export default {"openButton":"vlHOsECl"};